import { bus, helper } from '@/utils'

export default {
  name: 'NotificationsDelete',
  beforeDestroy () {
    bus.$off('show-delete-notification')
  },
  methods: {
    closePopup () {
      this.showModal = false
      this.loading = false
    },
    deleteNotification (id) {
      this.loading = true

      return this.$api.removeNotification(id)
        .then(() => {
          bus.$emit('get-notifications-list')
          this.closePopup()
          this.$message({
            message: this.$t('messageNotificationDelete'),
            showClose: true,
            type: 'success'
          })
        })
        .catch((error) => {
          this.loading = false
          helper.showErrorMessage(this, this.component, error)
        })
    }
  },
  data () {
    return {
      component: 'notificationsDelete',
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      id: null,
      loading: false,
      showModal: false
    }
  },
  mounted () {
    bus.$on('show-delete-notification', ({ show, id }) => {
      if (show) {
        this.showModal = true
      }

      if (id) {
        this.id = id
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/NotificationsDelete/NotificationsDelete.js